import { render, staticRenderFns } from "./ShiChangFenLei.vue?vue&type=template&id=0a92f36c&scoped=true&"
import script from "./ShiChangFenLei.vue?vue&type=script&lang=js&"
export * from "./ShiChangFenLei.vue?vue&type=script&lang=js&"
import style0 from "./ShiChangFenLei.vue?vue&type=style&index=0&id=0a92f36c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a92f36c",
  null
  
)

export default component.exports